// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3148d999","239":"1c355756","455":"edbe444a"}[chunkId] + ".chunk.js";
};